import React from 'react';
import PropTypes from 'prop-types';
import { Button, RFFormSelect } from 'virtues-bootstrap';
import { Field } from 'redux-form';
import { normalizeSearchInput } from 'utilities/normalize';
import HeaderSearchInput from '../HeaderSearchInput';

import s from './styles.module.scss';

function HeaderSearch({
  t,
  handleSubmit,
  submitting,
  searchValue,
  searchField,
  searchFields,
  defaultSearchField,
  onSubmit,
}) {
  const searchUsedField = searchField || defaultSearchField;
  const { key: titleSearchField } = searchFields.find(({ value }) => value === searchUsedField);

  const handleInputChange = event => {
    if ((event.target && !event.target.value) || event.type !== 'change') {
      onSubmit({ searchValue: '', page: 0 });
    }
  };

  return (
    <form onSubmit={handleSubmit} className={s.wrapper} data-test="searchForm">
      <Field name="type" component={RFFormSelect} className={s.select} placeholder={t('type')}>
        {searchFields.map(({ key, value }) => (
          <option key={key} value={value}>
            {key}
          </option>
        ))}
      </Field>
      <Field
        name="searchValue"
        component={HeaderSearchInput}
        className={s.search}
        normalize={normalizeSearchInput}
        placeholder={`${t('searchBy')} ${titleSearchField}`}
        data-test="searchPatientInput"
        onChange={handleInputChange}
      />
      <Button disabled={submitting || !searchValue}>{t('search')}</Button>
    </form>
  );
}

HeaderSearch.defaultProps = {
  searchField: null,
  searchValue: '',
};

HeaderSearch.propTypes = {
  defaultSearchField: PropTypes.string.isRequired,
  searchField: PropTypes.string,
  searchValue: PropTypes.string,
  searchFields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default HeaderSearch;
